import { safeSetLocalStorage } from './safeLocalStorage';
const broadcastThemeChange = () => {
  try {
    const reloadEvent = {
      type: 'trellis:theme'
    };
    window.postMessage(reloadEvent);
    for (let i = 0; i < window.frames.length; i++) {
      if (typeof window.frames[i].postMessage === 'function') {
        window.frames[i].postMessage(reloadEvent);
      }
    }
  } catch (e) {
    console.error('Error updating trellis theme, try reloading the page.');
  }
};

/**
 * This is a different key than the one used in the base theme switcher.
 * The base theme switcher uses 'trellis:theme', while this one uses 'hubspot-theme'.
 * This is intentional to avoid conflicts with the base theme switcher, since this
 * key is read by the `setup-theme.ts` file which is used to set _customer_ themes in specific apps,
 * while the `trellis:theme` key is used internally to set the default theme app-wide
 */
const EXTERNAL_LOCAL_STORAGE_KEY = 'hubspot-theme';
/**
 * Changes the customers theme.
 * Not read directly by ThemeProvider but rather used indirectly to set `html` data-attribute.
 */
export const changeThemeSetting = (themeName, themeMode) => {
  safeSetLocalStorage(EXTERNAL_LOCAL_STORAGE_KEY, `${themeName}-${themeMode}`);
};
export const changeThemeSettingWithLiveUpdate = (themeName, themeMode) => {
  changeThemeSetting(themeName, themeMode);
  broadcastThemeChange();
};
const INTERNAL_LOCAL_STORAGE_KEY = 'trellis:theme';
/**
 * @deprecated This changes the theme setting directly in local storage. Do not use this in new code.
 */
export const changeTheme = (themeName, themeMode) => {
  safeSetLocalStorage(INTERNAL_LOCAL_STORAGE_KEY, `${themeName}-${themeMode}`);
};

/**
 * @deprecated This changes the theme setting directly in local storage. Do not use this in new code.
 */
export const changeThemeWithLiveUpdate = (themeName, themeMode) => {
  changeTheme(themeName, themeMode);
  broadcastThemeChange();
};